<template>
  <div id="chat"
       class="video-chat-wrapper bg-contentDarkmodeAppbar border-box d-flex flex-column overflow-hidden" style="width: 460px; min-width:460px; border-width: 1px; margin-right: 117px;">
    <div class="video-chat-header">
      <div :class="lightModeActive?'bg-contentPlayerBgLight':'bg-secondaryBtn'" class="t-body2 font-r t-center font-m  t-color-contentText d-flex align-items-center h-36 justify-content-center">
        {{$t('1101')}}</div>
    </div>
    <div id="chatContainer" class=" flex-grow-1 scroll-y">
      <div class="w-full">
        <chat-list :listData="listData"></chat-list>
      </div>
    </div>
    <div class="divider-white"></div>
    <infinite-loading direction="top" force-use-infinite-wrapper="#chatContainer" @infinite="fetchData">
      <div slot="no-more" class="t-color-white">
      </div>
      <div slot="no-results" class="t-color-white">
      </div>
      <div slot="spinner"></div>
    </infinite-loading>
    <div class="chat-bottom-comment-fix">
      <div class="divider-white"></div>
      <div class="d-flex align-items-center justify-content-between">

        <chat-write
            :examineeId="examineeId"
            :learnId="learnId"
            :lessonId="lessonId"
            :lightModeActive="lightModeActive"
            :questionId="questionId"
            :roomId="roomId"
            @updateListData="updateListData"
        ></chat-write>
      </div>
      <div class="divider-white"></div>
      <div id="closeVideoChat" class="t-color-whiteMedium t-body3 t-center font-r pda-14 cursor-pointer t-capitalize" tabindex="0" @click="setisQuestionAnsHandlerChild">
        {{$t('3189')}}
      </div>
    </div>
  </div>
  <!-- <div id="chat" v-else>
    <main class="main-wrapper flex-grow-1 with-footer">
    <div class="d-flex align-items-center bg-white">
      <div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1">
        {{$t('1101')}}
      </div>
    </div>
    <div class="divider"></div>
    <infinite-loading direction="top" @infinite="fetchData" force-use-infinite-wrapper="#chatContainer">
      <div slot="no-more" class="t-color-white"></div>
      <div slot="no-results" class="t-color-white"></div>
      <div slot="spinner"> </div>
    </infinite-loading>
    <div class="container container--narrow mgt-50 mgb-80" id="chatContainer">
      <chat-list :listData="listData"></chat-list>
      <div ref="scrollBottom"></div>
    </div>
    </main>
    <div class="footer bg-white bottomStack" id="messageContainer2">
    <div class="divider"></div>
    <chat-write
      :learnId="learnId"
      :lessonId="lessonId"
      :roomId="roomId"
      :examineeId="examineeId"
      :questionId="questionId"
      @updateListData="updateListData"
    ></chat-write>
    </div>
  </div> -->

</template>

<script>
/**
 * 나의학습/시험 질문하기 - 메인 컴포넌트(my learn / exam question - main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import chatApi from '@/api/chatApi.js'
import ChatList from './ChatList.vue'
import ChatWrite from './ChatWrite.vue'
import InfiniteLoading from 'vue-infinite-loading'
export default {
  props: ['lightModeActive'],

  components: {
    'chat-list': ChatList,
    'chat-write': ChatWrite,
    InfiniteLoading,
  },

  data() {
    return {
      learnId: null,
      lessonId: null,
      roomId: null,

      examineeId: null,
      questionId: null,

      entered: false,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      showExamListChat :false
    }
  },

  computed: {
  },

  mounted() {
    if((this.$route.meta.chatType === 'exam' && this.$route.meta.TabType === 'ExamList') ||
        (this.$route.meta.chatType === 'lesson' && this.$route.meta.TabType === 'LearnList')){
      this.showExamListChat = true;
    }
    else{
      this.showExamListChat = false;
    }
    this.learnId = this.$route.params.learnId
    this.lessonId = this.$route.params.lessonId
    this.fetchData()
  },
  watch: {
    $route(to, from) {
      console.log(to, from, ' ___to from data')

    }
  },
  methods: {
    setisQuestionAnsHandlerChild(){
      this.$emit('setisQuestionAnsHandler')
    },

    fetchData($state) {

      if (this.$route.meta.chatType === 'exam') {
        this.fetchExamChatData($state)
      }else {
        this.fetchLearnChatData($state)
      }


    },

    // set parameter for learn question
    setParamsLearn() {
      let params = {
        learnId: this.learnId,
        lessonId: this.lessonId,
        roomId: this.roomId,
        page: this.currentPage,
        size: 50,
        sort: 'id,desc'
      }
      return params
    },

    // set parameter for exam question
    setParamsExam() {
      let params = {
        examineeId: this.examineeId,
        questionId: this.questionId,
        roomId: this.roomId,
        page: this.currentPage,
        size: 50,
        sort: 'id,desc'
      }
      return params
    },


    moveScrollBottom() {
      let element = this.$refs.scrollBottom
      let options = {
        container: '#chatContainer',
        easing: 'ease-in'
      }
      this.$scrollTo(element, 100, options)
    },

    // update chatting list data
    updateListData(data) {
      this.listData.push(data)
      this.roomId = data.roomId
      this.moveScrollBottom()
    },

    // get chatting list data for exam
    fetchExamChatData($state) {
      this.examineeId = this.$route.params.examineeId
      this.questionId = this.$route.params.questionId

      let params = {
        examineeId: this.examineeId,
        questionId: this.questionId
      }

      chatApi.examChatroomQuestion(params).then((response) => {
        this.entered = response.data.data.entered
        this.roomId = response.data.data.id
        if (response.data.data.entered) {
          params = this.setParamsExam()

          if (this.totalPages >= this.currentPage) {
            chatApi.examChatroomChatList(params).then((response) => {
              let responseData = response.data.data
              this.currentPage++
              this.totalPages = responseData.totalPages
              this.listData.unshift(...responseData.content.reverse());

              if (responseData.content.length) {
                $state.loaded()
              }else {
                $state.complete()
              }

              chatApi.examChatroomChatRead(params).then((response) => {

              }).catch((err) => {

              })
            })
          }else {
            $state.complete()
          }
        }else {
          $state.complete()
        }

      }).catch((err) => {
      })
    },

    // get chatting list data for my learn
    fetchLearnChatData($state) {
      this.learnId = this.$route.params.learnId
      this.lessonId = this.$route.params.lessonId
      let params = {
        learnId: this.learnId,
        lessonId: this.lessonId
      }

      // get chatting room information
      chatApi.learnChatroomLesson(params).then((response) => {
        this.entered = response.data.data.entered
        this.roomId = response.data.data.id
        if (response.data.data.entered) {
          params = this.setParamsLearn()

          if (this.totalPages >= this.currentPage) {
            // get chatting list
            chatApi.learnChatroomChatList(params).then((response) => {
              let responseData = response.data.data
              this.currentPage++
              this.totalPages = responseData.totalPages
              this.listData.unshift(...responseData.content.reverse());

              if (responseData.content.length) {
                $state.loaded()
              }else {
                $state.complete()
              }
              // set readed
              chatApi.learnChatroomChatRead(params).then((response) => {}).catch((err) => {})
            })
          }else {
            $state.complete()
          }

        }else {
          $state.complete()
        }

      }).catch((err) => {})
    }
  }
}
</script>
